module.exports = __webpack_public_path__ + "img/12.098d116e.jpg";